import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
  providers: [AuthenticationService]
})
export class ForgotPasswordComponent implements OnInit {

  email: string;
  successMessage: string;

  constructor(private authService: AuthenticationService) { }

  ngOnInit() {
  }

  send() {
    this.authService.sendRecoveryPasswordEmail(this.email);
    this.email = '';
    this.successMessage = 'E-mail de redefinição de senha enviado com suceso. Por favor, verifique a sua caixa de entrada.';
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/forgot-password/forgot-password.component.ts